import { RowNode } from "ag-grid-community";

export enum fgDrilldown {
  Registration = "등록",
  Search = "조회",
}

export interface menuInfo {
  cd_menu?: string;
  nm_menu?: string;
  cd_module?: string;
  figure?: fgDrilldown;
  nodeData?: any;
  originMenu?: any;
}

export interface activeMenuInfo {
  cd_menu: string;
  nm_menu?: string;
  cd_module?: string;
}

export type ChatScreenSelectionValue = string | number | boolean;

export type ChatScreenSelection = Record<string, ChatScreenSelectionValue>;

export type ChatSearchFormValue = string | number | boolean | null | undefined;

export type ChatSearchFormData = Record<string, ChatSearchFormValue>;

export type ChatScreenDataRow = Record<string, ChatSearchFormValue>;

export interface ChatScreenColumn {
  field: string;
  label: string;
  visible: boolean;
  type?: string;
  displayField?: string;
  codeClass?: string;
  gridId?: string;
}

export interface ChatScreenGridData {
  rows?: ChatScreenDataRow[];
  selectedRows?: ChatScreenDataRow[];
  visibleRows?: ChatScreenDataRow[];
  visibleColumns?: ChatScreenColumn[];
  filters?: ChatSearchFormData;
  /** 현재 조회된 실제 행수(캡 이전). "몇 건" 답변이 1000 캡에 안 걸리게 참 건수를 담는다. */
  rowCount?: number;
  /** rows(필터 전 전체 행)의 캡 이전 건수 (2026-10-16). rowCount 는 필터 후라 rows 와 범위가 다르다 — 보고서 부분 집계 판정용 */
  rowsTotal?: number;
}

export interface ChatScreenData {
  rows?: ChatScreenDataRow[];
  selectedRows?: ChatScreenDataRow[];
  visibleRows?: ChatScreenDataRow[];
  visibleColumns?: ChatScreenColumn[];
  filters?: ChatSearchFormData;
  grids?: Record<string, ChatScreenGridData | undefined>;
  /** 현재 조회된 실제 행수(캡 이전) — 건수 답변용. */
  rowCount?: number;
  /** rows(필터 전 전체 행)의 캡 이전 건수 (2026-10-16). 단일 그리드 수집 → provider 병합에서 grids 로 옮겨진다 */
  rowsTotal?: number;
}

export interface ChatSearchPanelHandle {
  getFormdata: () => ChatSearchFormData | undefined;
  setFormdata: (data: ChatSearchFormData) => void;
  getAllowedFieldNames: () => string[];
  /** 코드 칸 · 콤보 칸 정의 — 챗봇이 넣은 이름을 화면이 찾아 채울 때 쓴다 (2026-10-02) */
  getChatFields?: () => ChatSearchField[];
  /** 조회조건 초기화(↻)와 같은 처리. 화면이 초기화 버튼을 숨겼으면 없다 (2026-10-16) */
  resetFormdata?: () => void;
}

/** 조회조건 칸 하나 (챗봇 값 맞추기용) */
export interface ChatSearchField {
  /** cd_param 의 첫 이름 */
  param: string;
  tp_ctrl: string;
  nm_label?: string;
  cd_popup?: string;
  cd_clas?: string;
  cd_displaycolumn?: string;
  js_combo?: any;
}

export interface ChatScreenDataProviderHandle {
  getScreenData: () => ChatScreenData | undefined;
  /** 챗봇 행추가 · 행복사가 쓰는 그리드 동작(새 그리드만, 2026-10-15). 사람이 [+] 를 누르고 칸에 입력한 것과 같은 길 */
  chatActions?: ChatGridActions;
}

/** 바꿀 값 넣기 결과 — 칸 이름(요청에 온 그대로) */
export interface ChatValuesResult {
  applied: string[];
  /** 입력할 수 없는 칸 */
  locked: string[];
  /** 이 그리드에 없는 칸 */
  notFound: string[];
  /** 코드를 못 찾았거나 여러 개 */
  unresolved: string[];
}

/** 그리드가 챗봇에 내주는 동작 — 화면별 챗봇 코드 없이 표준 처리(onBtnAddClick · setDataValue)를 탄다 */
export interface ChatGridActions {
  /** 그리드 [+] 버튼을 누른 것과 같다 — 화면이 연결한 onBtnAddClick("addRow"). 버튼이 없으면 false */
  pressAdd: () => boolean;
  /** 커서가 있는 행 */
  focusedRow: () => { data?: Record<string, unknown> } | null | undefined;
  /** 고른 줄 — 체크박스로 체크한 줄 → 끌어 잡은 범위(여러 줄) → 커서 줄 */
  selectedRows: () => Record<string, unknown>[];
  /** 화면에 보이는 행(필터 · 정렬 뒤) */
  displayedRows: () => Record<string, unknown>[];
  rowCount: () => number;
  /** 이 그리드에 [+](행추가) 가 있는지 — 없으면 챗봇 행추가 대상이 아니다(현황 같은 조회 메뉴) */
  canAdd: () => boolean;
  /**
   * 커서가 있는 행에 원본 값을 사람이 입력하듯 넣는다 — 보이고 입력 가능한 칸만, 새 행 기본값은 덮지 않는다(빈 칸 · 0 만).
   * exclude 칸(상단 · 하단을 잇는 문서번호)은 건너뛴다. 넣은 칸 이름
   */
  copyFocused: (source: Record<string, unknown>, exclude?: string[]) => Promise<string[]>;
  /** 상단 → 하단 거름에 쓰는 칸(문서번호). 상단 그리드만 있다 */
  linkKeys: () => string[];
  /** 칸 이름 또는 화면 제목 → 칸 이름. 이 그리드에 없으면 null */
  fieldOf: (nameOrLabel: string) => string | null;
  /** field 값이 value 인 행 수. 하나면 그 행으로 커서를 옮긴다 */
  focusByField: (field: string, value: string) => number;
  /** 보이는 순서(0부터)의 행으로 커서를 옮긴다. 없으면 false */
  focusIndex: (index: number) => boolean;
  /** 지금 있는 줄들의 표시(행추가 전에 잡아 둔다) */
  rowIds: () => string[];
  /** before 에 없던 줄(새 행)로 커서를 옮긴다. 못 찾으면 false */
  focusNew: (before: string[]) => boolean;
  /** 켜 두는 동안 빈 코드 칸에 커서가 가도 도움창을 자동으로 열지 않는다(챗봇 행복사 중) */
  setQuiet: (on: boolean) => void;
  /**
   * 커서가 있는 행에 바꿀 값을 넣는다 — 칸은 화면 제목 · 칸 이름으로 찾는다. 사용자가 말한 값이라 기본값보다 우선.
   * 코드 칸은 resolveCode(도움창 코드, 글, 분류)로 코드를 찾아 하나일 때만 넣는다
   */
  applyValues: (
    values: Record<string, string>,
    resolveCode: (popup: string, text: string, cdClas?: string) => Promise<string | null>
  ) => Promise<ChatValuesResult>;
  /** 칸 이름 또는 화면 제목이 이 그리드의 코드 칸이면 그 제목 · 도움창 · 분류. 아니면 null (2026-10-21) */
  codeColumnOf: (nameOrLabel: string) => { label: string; popup: string; cdClas?: string } | null;
}

/**
 * 챗봇 행추가 v2 — 화면 함수(onChatAddRow) 계약(docs/DESIGN-chatbot-addrow-screen-function.md).
 * 화면이 imperativeHandle에 onChatAddRow를 노출하면 그 메뉴는 행추가를 지원한다(함수 유무 = 선언).
 * AI는 의도(mode/scope)만 넘기고, 복제·키 처리·계산·매핑은 전부 화면 함수가 수행한다.
 */
/** 어느 그리드에 넣을지 — 상단 / 하단 / 마스터+디테일(모두). */
export type ChatAddRowScope = "master" | "detail" | "all";

/**
 * copyByKey 기준 건(2026-09-01). field = 백엔드가 받은 화면 선언 PK(addRowKeyField), value = 지목한 값.
 * 화면 함수는 자기 lineKey.fk와 field가 같을 때만 실행한다(계약 위반 차단). value는 항상 문자열.
 */
export interface ChatAddRowSourceKey {
  field: string;
  value: string;
}

/**
 * 판별 유니온 — copyByKey인데 sourceKey가 없는 상태는 컴파일되지 않는다.
 *  - copySelected: 현재 선택 행(들) 복제(v1).
 *  - copyByKey: sourceKey로 지목한 상단 행(+소속 하단 라인) 복제(v2, 2026-09-01).
 *  - (예약, 미구현) newWithValues: IDP 문서→행. { mode: "newWithValues"; scope; values }
 */
export type ChatAddRowRequest = (
  | { mode: "new"; scope: ChatAddRowScope }
  | { mode: "copySelected"; scope: ChatAddRowScope }
  /** 줄 지목 — 화면 왼쪽 No(1부터, 마지막은 -1). "2번 품목" · "두 번째" (2026-10-15) */
  | { mode: "copyByRow"; scope: ChatAddRowScope; rowNo: number }
  | { mode: "copyByKey"; scope: ChatAddRowScope; sourceKey: ChatAddRowSourceKey }
) & {
  /** 새 행에 넣을 값 — 칸 이름(화면 제목) → 값. 코드 칸은 이름도 된다. 화면 기본값보다 우선 (2026-10-15) */
  values?: Record<string, string>;
  /** 화면 전용 — 번호 버튼으로 고른 코드(values 의 칸 이름 → 코드). 이 칸은 다시 찾지 않는다 (2026-10-21) */
  codes?: Record<string, string>;
};

/** 화면 함수의 결과 — 챗봇은 이 message 하나만 렌더한다(단일 진실원). */
export interface ChatAddRowResult {
  ok: boolean;
  addedCount: number;
  message: string;
  /** 바꿀 코드 값의 후보가 여럿 — 행을 만들기 전에 멈추고 번호 버튼으로 고르게 한다 (2026-10-21) */
  pick?: ChatFieldPick;
}

export type ChatAddRowCallResult =
  | { readonly status: "EXECUTED"; readonly result: ChatAddRowResult }
  | { readonly status: "MENU_MISMATCH" }
  | { readonly status: "UNSUPPORTED" };

export type ChatScreenGridDataProviders = Record<
  string,
  Record<string, ChatScreenDataProviderHandle | undefined> | undefined
>;

export interface ChatSearchApplyResult {
  applied: boolean;
  ignoredParams: string[];
  reason?:
    | "NO_ACTIVE_SEARCH_PANEL"
    | "MENU_MISMATCH"
    | "NO_ALLOWED_PARAMS"
    | "SEARCH_NOT_RUN"
    | "CODE_NOT_PICKED"
    | "CODE_PICK_NEEDED"
    | "RESET_UNSUPPORTED";
  /** 사용자에게 보일 한 줄 (있으면 이것을 쓴다) */
  message?: string;
  /** 후보가 여럿 — 채팅에 번호 버튼을 띄워 고르게 한다 */
  pick?: ChatFieldPick;
}

/**
 * 채팅에서 고를 후보 — 프로그램이 들고 있다가 고르면 AI 없이 이어간다 (2026-10-02)
 *   target "field"  : 코드 · 콤보 칸 값. 고르면 그 코드로 조건을 다시 넣어 조회
 *   target "menu"   : 열 메뉴. 고르면 그 메뉴를 열고 patch 를 조건으로 적용 (2026-10-06)
 *   target "addRow" : 행복사의 바꿀 코드 값. 고르면 그 코드로 행복사를 처음부터 한다 (2026-10-21)
 */
export interface ChatFieldPick {
  target: "field" | "menu" | "addRow";
  /** 행복사 요청 (target addRow). field 는 그 values 의 칸 이름 */
  addRow?: ChatAddRowRequest;
  menuCode?: string;
  /** 코드를 넣을 칸 (target field) */
  field?: string;
  /** 이름을 넣을 칸(코드 칸의 cd_displaycolumn) */
  displayField?: string;
  label: string;
  /** 채팅에 보일 안내 한 줄 */
  prompt: string;
  /** patch — 메뉴 후보마다 그 메뉴의 칸 이름으로 옮긴 조건(2026-10-13). 없으면 아래 공통 patch */
  candidates: { code: string; name: string; patch?: ChatSearchFormData }[];
  /** 고른 값을 끼워 다시 넣을 조건 전체 */
  patch: ChatSearchFormData;
  /** 메뉴 후보 — 고른 메뉴를 조건이 없어도 열고 조회한다 (2026-10-14) */
  search?: boolean;
  /** 칸 후보 — false 면 고른 값을 넣기만 하고 조회하지 않는다("○○로 설정해줘", 2026-10-16) */
  run?: boolean;
  /** 조회하고 답하기 — 고른 뒤 조회가 끝나면 이 질문을 다시 보내 조회된 화면으로 답하게 한다(값을 묻는 말, 2026-10-21) */
  ask?: string;
}

export interface userInfo {
  cd_lang?: string;
  cd_firm?: string;
  nm_firm?: string;
  cd_biz?: string;
  nm_biz?: string;
  fg_biz_grt?: string;
  dc_ip?: string;
  dc_mac?: string;
  cd_dept?: string;
  nm_dept?: string;
  cd_emp?: string;
  nm_emp?: string;
  nm_emp_e?: string;
  cd_user?: string;
  nm_user?: string;
  dc_email?: string;
  cd_exchange?: string;
  fg_pos?: string;
  nm_fg_pos?: string;
  fg_role?: string;
  nm_fg_role?: string;
  cd_gra?: string;
  dc_socket?: string;
  cd_gp?: string;
  nm_gp?: string;
  nm_photo?: string;
  cd_menu_dashboard?: string;
  loginTime?: string;
  fg_user?: string;
  cd_cust?: string;
  tenant_id?: string;
  /** "Y" 면 AI 를 쓸 수 있는 회사. 헤더의 SNotes AI Bot 버튼을 그린다 (2026-09-21) */
  yn_ai?: string;

  [key: string]: string | undefined;
}

export interface globalInfo {
  userInfo: userInfo;
  setUserInfo: (newState: userInfo) => void;
  config: any;
  setConfig: (newState: any) => void;
  bookmark: any;
  setBookmark: (newState: any) => void;
}

export interface globalMenuInfo {
  activeMenuInfo: activeMenuInfo;
  setActiveMenuInfo: (newState: activeMenuInfo) => void;
  chatScreenSelections: Record<string, ChatScreenSelection | undefined>;
  setChatScreenSelection: (
    cd_menu: string,
    selection: ChatScreenSelection
  ) => void;
  clearChatScreenSelection: (cd_menu: string) => void;
}

export interface globalFooterMsg {
  footerMsg: Map<string, string>;
  handleFooterMsg: (cd_menu: string, message: string) => void;
}

export interface globalSearch {
  onSearchInfo: onSearchInfo;
  chatSearchPanels: Record<string, ChatSearchPanelHandle | undefined>;
  chatScreenDataProviders: Record<
    string,
    ChatScreenDataProviderHandle | undefined
  >;
  chatScreenGridDataProviders: ChatScreenGridDataProviders;
  setOnSearch: (newState: onSearchInfo) => void;
  runOnSearch: (targetMenuCode?: string) => Promise<boolean>;
  registerSearchPanel: (
    cd_menu: string,
    handle: ChatSearchPanelHandle
  ) => void;
  /** handle 을 주면 그 칸이 그 handle 일 때만 지운다(다른 패널이 맡긴 것은 두고) */
  unregisterSearchPanel: (cd_menu: string, handle?: ChatSearchPanelHandle) => void;
  registerChatScreenDataProvider: (
    cd_menu: string,
    handle: ChatScreenDataProviderHandle
  ) => void;
  unregisterChatScreenDataProvider: (cd_menu: string) => void;
  registerChatScreenGridDataProvider: (
    cd_menu: string,
    grid_key: string,
    handle: ChatScreenDataProviderHandle
  ) => void;
  unregisterChatScreenGridDataProvider: (
    cd_menu: string,
    grid_key: string
  ) => void;
  getCurrentSearchFormData: () => ChatSearchFormData | undefined;
  applySearchParamsAndRun: (
    paramsPatch: ChatSearchFormData,
    targetMenuCode?: string,
    /** reset: 조회조건 초기화(↻) 먼저 · run false: 조건만 넣고 조회하지 않는다 (2026-10-16) */
    options?: { reset?: boolean; run?: boolean }
  ) => Promise<ChatSearchApplyResult>;
  getCurrentChatScreenData: () => ChatScreenData | undefined;
  /** 활성 화면이 챗봇 행추가(onChatAddRow)를 지원하는지 — /도움·스냅샷 신호용. */
  supportsChatAddRow: () => boolean;
  /** 활성 화면이 선언한 행추가 PK 필드(onChatAddRow.keyField) — 스냅샷 런타임 메타 addRowKeyField. */
  chatAddRowKeyField: () => string | undefined;
  /**
   * 챗봇 행추가 v2 — 활성 화면의 onChatAddRow를 호출한다(저장은 사용자).
   * 실행 여부와 실패 사유는 ChatAddRowCallResult 상태로 구분한다.
   */
  callChatAddRow: (
    request: ChatAddRowRequest,
    targetMenuCode?: string
  ) => Promise<ChatAddRowCallResult>;
}

export interface onSearchInfo {
  index?: number;
  componentRefs?: any[];
  menuData?: any[];
  isLoading?: (cd_menu: string, state: boolean) => void;
  tabTitle?: (cd_menu: string, state: boolean) => void;
}

export interface requestControllerState {
  controllerMap: Map<string, AbortController>;
  setController: (menuId: string, controller: AbortController) => void;
  abortController: (menuId: string) => void;
  removeController: (menuId: string) => void;
}

type LoadingType = "search" | "save" | null;

/** 메뉴별 저장하지 않은 수정 건수 — 그리드 · 입력폼이 등록하고 메뉴 닫기(MainLayout closeMenus)가 묻는다 (2026-10-16) */
export interface MenuChangeState {
  counters: Record<string, Record<string, () => number>>;
  register: (menuId: string, id: string, count: () => number) => void;
  unregister: (menuId: string, id: string) => void;
  /** 그 메뉴의 그리드 · 입력폼 수정 건수 합 */
  changedCount: (menuId: string) => number;
}

/**
 * 메뉴 화면 진행 창 — 메뉴별 한 일 · 할 일. 메뉴 화면 덮개(ChatCopyProgress)가 읽는다 (2026-10-16 챗봇 행복사).
 * 2026-10-22 제목 · 문구를 받는다(회의록 전사). 안 주면 행복사 그대로("행 복사" · "N / 전체건 복사 중입니다."). total 이 0 이면 막대만 흐른다(진행률 모름)
 */
export interface ChatCopyProgressOptions {
  title?: string;
  message?: string;
}

export interface ChatCopyProgressState {
  progress: Record<string, ({ done: number; total: number } & ChatCopyProgressOptions) | undefined>;
  setProgress: (menuId: string, done: number, total: number, options?: ChatCopyProgressOptions) => void;
  clearProgress: (menuId: string) => void;
}

export interface loadingState {
  loadingTypeMap: Map<string, LoadingType>;
  setLoadingType: (menuId: string, type: LoadingType) => void;
  getLoadingType: (menuId: string) => LoadingType;
  clearLoadingType: (menuId: string) => void;
}

export interface Menu {
  cd_menu: string;
  nm_menu: string;
  nm_menu_origin: string;
  cd_module: string;
  no_pos: string;
  nm_file: string;
  fg_menu: string;
  no_seq: number;
  no_level: number;
  cd_menu_parent?: string | null;
  fg_select: string;
  fg_insert: string;
  fg_update: string;
  fg_delete: string;
  fg_excel: string;
  fg_print: string;
  yn_end: string;
  path_arr?: string[];
  path_origin?: string[];
  nm_path?: string;
}

export interface MenuStore {
  menuItems: Menu[];
  setMenuItems: (items: Menu[]) => void;
  expandedMap: Record<string, boolean>;
  setExpandedMap: (map: Record<string, boolean>) => void;
  clearExpandedMap: () => void;
}

export interface SnEditorState {
  handlers: Record<string, () => void>;
  register: (id: string, handler: () => void) => void;
  unregister: (id: string) => void;
  trigger: (id: string) => void;
}

export type NavigationStore = {
  navigate: ((path: string) => void) | null;
  setNavigate: (nav: (path: string) => void) => void;
};

export interface EditValueChangedEvent {
  newValue: any;
  oldValue: any;
  colId: string;
  rowData: any;
  rowIndex: number;
  rowNode: RowNode;
}

export interface ValueChangedEvent {
  newValue: any;
  oldValue: any;
  colId: string;
  rowData: any;
}

export type TpCtrl = (typeof TpCtrlList)[number];

export const TpCtrlList = [
  "SnLabel",
  "SnTextBox",
  "SnPasswordBox",
  "SnNumberBox",
  "SnMaskBox",
  "SnDateBox",
  "SnPeriodBox",
  "SnCodeBox",
  "SnCodeNTextBox",
  "SnComboBox",
  "SnMemoBox",
  "SnButton",
  "SnGroupLabel",
  "SnTab",
  "SnRadioBox",
  "SnCheckBox",
  "SnDateMonthBox",
  "SnDateYearBox",
  "SnPeriodMonthBox",
  "SnPeriodMonthBoxPop",
  "SnMultiCodeBox",
  "SnMultiComboBox",
  "SnComboPeriodBox",
  "SnCheckPeriodBox",
  "SnComboTextBox",
  "SnEmpty",
  "SnProjectDetail",
  "SnItemDetailBox",
  "SnStyleCodeNTextBox",
  "SnMultiCodeNameBox",
  "SnItemInfoBox",
  "SnItemDetailBox2",
  "SnItemDetail",
  "SnImageBox",
  "SnYearPeriodBox",
  "SnYearWeekPicker",
  "SnBarcodeBox",
  "SnPeriodTextBox",
  "SnPeriodTimeBox",
  "SnSwitch",
  "SnChipInput",
  "SnAudioRecorder",
  "SnEditor",
  "SnFileUploadBox",
  "SnVarProps",
  "SnVarSet",
  "SnLinkedInfoBox",
  "SnStepUp",
] as const;
